"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("./extends-fa579b0f.js"),
  a = require("react"),
  r = require("prop-types"),
  l = require("classnames"),
  n = require("./taggedTemplateLiteral-97b463ad.js"),
  o = require("styled-components"),
  d = require("polished/lib/helpers/rem");
function c(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var u,
  i,
  s,
  f,
  p,
  m,
  g,
  b,
  h,
  v,
  w,
  T,
  y,
  _,
  S,
  O,
  k,
  L,
  B,
  j,
  N,
  x,
  E,
  H = c(a),
  P = c(r),
  q = c(l),
  D = c(o),
  R = c(d),
  U = function U(e, t) {
    var a = e.mediumUp(),
      r = a ? "".concat(R["default"](8), " ").concat(R["default"](4), " ").concat(R["default"](8), " ").concat(R["default"](12)) : "".concat(R["default"](8), " ").concat(R["default"](4), " ").concat(R["default"](8), " ").concat(R["default"](8));
    return "branded" === t && (r = a ? "".concat(R["default"](16), " ").concat(R["default"](16), " ").concat(R["default"](16), " ").concat(R["default"](32)) : "".concat(R["default"](16), " ").concat(R["default"](4), " ").concat(R["default"](16), " ").concat(R["default"](8))), r;
  },
  A = D["default"].table(u || (u = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme;
    return o.css(i || (i = n._taggedTemplateLiteral(["\n    width: 100%;\n    border: ", " solid ", ";\n    border-collapse: collapse;\n    background-color: ", ";\n    caption {\n      display: none;\n    }\n  "])), R["default"](1), t.colors.stroke.lightTheme.tableBorder, t.colors.background.lightTheme.lightA);
  }),
  F = D["default"].tr(s || (s = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.variant;
    return o.css(f || (f = n._taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), "branded" === a ? t.colors.background.darkTheme.darkDefault : t.colors.background.lightTheme.lightA);
  }),
  $ = function $(e, t, a, r) {
    var l = r && (r.includes("px") ? R["default"](r) : r);
    return o.css(p || (p = n._taggedTemplateLiteral(["\n    ", ";\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: 500;\n    color: ", ";\n    ", "\n  "])), l && "width: ".concat(l), U(t, a), t.mediumUp ? R["default"](21) : R["default"](17), t.mediumUp ? R["default"](28) : R["default"](24), "branded" === a ? t.colors.text.darkTheme["default"] : t.colors.text.lightTheme["default"], !e && o.css(m || (m = n._taggedTemplateLiteral(["\n      border: ", " solid ", ";\n    "])), R["default"](1), t.colors.stroke.lightTheme.tableBorder));
  },
  z = D["default"].th(g || (g = n._taggedTemplateLiteral(["\n  ", ";\n"])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant,
      l = e.$width;
    return $(t, a, r, l);
  }),
  I = D["default"].td(b || (b = n._taggedTemplateLiteral(["\n  ", ";\n"])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant,
      l = e.$width;
    return $(t, a, r, l);
  }),
  C = D["default"].tr(h || (h = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.displayStripedRows,
      a = e.rowIndex,
      r = e.theme;
    return o.css(v || (v = n._taggedTemplateLiteral(["\n    ", "\n  "])), t && a % 2 != 0 && o.css(w || (w = n._taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), r.colors.background.lightTheme.lightB));
  }),
  G = function G(e, t, a) {
    return o.css(T || (T = n._taggedTemplateLiteral(["\n  padding: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: 400;\n  ", "\n"])), U(t, a), t.mediumUp ? R["default"](18) : R["default"](15), t.mediumUp ? R["default"](28) : R["default"](24), !e && o.css(y || (y = n._taggedTemplateLiteral(["\n      border: ", " solid ", ";\n  "])), R["default"](1), t.colors.stroke.lightTheme.tableBorder));
  },
  J = D["default"].th(_ || (_ = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant;
    return o.css(S || (S = n._taggedTemplateLiteral(["\n    ", ";\n    ", "\n  "])), G(t, a, r), "branded" === r && o.css(O || (O = n._taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), a.colors.background.lightTheme.lightB));
  }),
  K = D["default"].td(k || (k = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant;
    return o.css(L || (L = n._taggedTemplateLiteral(["\n    ", ";\n  "])), G(t, a, r));
  }),
  M = function M(e, t, a) {
    return o.css(B || (B = n._taggedTemplateLiteral(["\n  ", ";\n   /** add/adjust footer-cell-specific styles here */\n"])), G(e, t, a));
  },
  Q = D["default"].th(j || (j = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant;
    return o.css(N || (N = n._taggedTemplateLiteral(["\n    ", ";\n    background-color: ", ";\n  "])), M(t, a, r), "branded" === r ? a.colors.background.lightTheme.lightB : a.colors.background.lightTheme.lightA);
  }),
  V = D["default"].td(x || (x = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.removeTableBorder,
      a = e.theme,
      r = e.variant;
    return o.css(E || (E = n._taggedTemplateLiteral(["\n    ", ";\n  "])), M(t, a, r));
  });
function W(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, r);
  }
  return a;
}
function X(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = null != arguments[a] ? arguments[a] : {};
    a % 2 ? W(Object(r), !0).forEach(function (a) {
      e._defineProperty(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : W(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }
  return t;
}
var Y = function Y(e) {
    return "row" === e || "rowgroup" === e ? {
      scope: e
    } : {};
  },
  Z = function Z(e, a, r, l) {
    var n;
    return H["default"].createElement(F, {
      key: "head-row".concat(r + 1),
      variant: l
    }, null === (n = a.cols) || void 0 === n ? void 0 : n.map(function (a, n) {
      return function (e, a, r, l, n) {
        var o,
          d = !e.children || void 0 !== e.isHeader && !e.isHeader ? I : z;
        return H["default"].createElement(d, t._extends({}, e.className && {
          className: e.className
        }, e.colSpan && {
          colSpan: e.colSpan
        }, e.id && {
          id: e.id
        }, {
          key: "head-row".concat(l + 1, "-col").concat(a + 1),
          $width: e.width,
          removeTableBorder: r
        }, "col" === (o = e.colScope) || "colgroup" === o ? {
          scope: o
        } : {}, {
          variant: n
        }), e.children);
      }(a, n, e, r, l);
    }));
  },
  ee = function ee(e, a, r, l, n) {
    var o;
    return H["default"].createElement(C, {
      displayStripedRows: e,
      key: "body-row".concat(l + 1),
      rowIndex: l
    }, null === (o = r.cols) || void 0 === o ? void 0 : o.map(function (e, r) {
      return function (e, a, r, l, n) {
        var o = e.isHeader ? J : K;
        return H["default"].createElement(o, t._extends({}, e.className && {
          className: e.className
        }, e.colSpan && {
          colSpan: e.colSpan
        }, {
          headers: e.headers
        }, e.id && {
          id: e.id
        }, {
          key: "body-row".concat(l + 1, "-col").concat(a + 1),
          removeTableBorder: r
        }, e.rowSpan && {
          rowSpan: e.rowSpan
        }, Y(e.rowScope), {
          variant: n
        }), e.children);
      }(e, r, a, l, n);
    }));
  },
  te = function te(e) {
    var a,
      r,
      l,
      n,
      o,
      d,
      c = e.className,
      u = e.removeTableBorder,
      i = e.tableData,
      s = e.variant;
    return H["default"].createElement(A, t._extends({
      className: q["default"]("nmx-table", c)
    }, i.summary && {
      summary: i.summary
    }), i.caption && i.caption.children && H["default"].createElement("caption", {
      className: "nmx-table__caption"
    }, i.caption.children), i.tableHead && H["default"].createElement("thead", {
      className: "nmx-table__head"
    }, null === (a = i.tableHead) || void 0 === a || null === (r = a.rows) || void 0 === r ? void 0 : r.map(function (e, t) {
      return Z(u, e, t, s);
    })), H["default"].createElement("tbody", {
      className: "nmx-table__body"
    }, null === (l = i.tableBody) || void 0 === l || null === (n = l.rows) || void 0 === n ? void 0 : n.map(function (e, t) {
      return ee(i.tableBody.displayStripedRows, u, e, t, s);
    })), i.tableFoot && H["default"].createElement("tfoot", {
      className: "nmx-table__foot"
    }, null === (o = i.tableFoot) || void 0 === o || null === (d = o.rows) || void 0 === d ? void 0 : d.map(function (e, a) {
      var r;
      return H["default"].createElement("tr", {
        key: "foot-row".concat(a + 1)
      }, null === (r = e.cols) || void 0 === r ? void 0 : r.map(function (e, r) {
        return function (e, a, r, l, n) {
          var o = e.isHeader ? Q : V;
          return H["default"].createElement(o, t._extends({}, e.className && {
            className: e.className
          }, e.colSpan && {
            colSpan: e.colSpan
          }, e.id && {
            id: e.id
          }, {
            key: "foot-row".concat(l + 1, "-col").concat(a + 1),
            removeTableBorder: r
          }, e.rowSpan && {
            rowSpan: e.rowSpan
          }, Y(e.rowScope), {
            variant: n
          }), e.children);
        }(e, r, u, a, s);
      }));
    })));
  },
  ae = {
    children: P["default"].oneOfType([P["default"].string, P["default"].node]),
    className: P["default"].string,
    colSpan: P["default"].number,
    id: P["default"].string
  };
te.propTypes = {
  className: P["default"].string,
  removeTableBorder: P["default"].bool,
  tableData: P["default"].shape({
    caption: P["default"].shape({
      children: P["default"].oneOfType([P["default"].node, P["default"].string])
    }),
    summary: P["default"].oneOfType([P["default"].object, P["default"].string]),
    tableHead: P["default"].shape({
      rows: P["default"].arrayOf(P["default"].shape({
        cols: P["default"].arrayOf(P["default"].shape(X(X({}, ae), {}, {
          colScope: P["default"].oneOf(["col", "colgroup"]),
          isHeader: P["default"].bool,
          width: P["default"].string
        })))
      }))
    }),
    tableBody: P["default"].shape({
      displayStripedRows: P["default"].bool,
      rows: P["default"].arrayOf(P["default"].shape({
        cols: P["default"].arrayOf(P["default"].shape(X(X({}, ae), {}, {
          headers: P["default"].string,
          isHeader: P["default"].bool,
          rowScope: P["default"].oneOf(["row", "rowgroup"]),
          rowSpan: P["default"].number
        })))
      }))
    }),
    tableFoot: P["default"].shape({
      rows: P["default"].arrayOf(P["default"].shape({
        cols: P["default"].arrayOf(P["default"].shape(X(X({}, ae), {}, {
          isHeader: P["default"].bool,
          rowSpan: P["default"].number,
          rowScope: P["default"].oneOf(["row", "rowgroup"])
        })))
      }))
    })
  }).isRequired,
  variant: P["default"].oneOf(["generic", "branded"])
}, te.defaultProps = {
  removeTableBorder: !1,
  tableData: {
    tableBody: {
      displayStripedRows: !1
    },
    tableHead: {
      rows: [{
        cols: [{
          isHeader: !0
        }]
      }]
    }
  },
  variant: "generic"
}, exports.TableComponent = te;